import { createProgrammaticComponentManager } from '@zoom/zoom-ui-vue3'

export default createProgrammaticComponentManager()
